import React from 'react'
import Banner from '../Components/Banner'
import BannerImage from "../Images/faq-banner.jpg"
import { Container, Row, Col, Accordion } from 'react-bootstrap'

const Faq = () => {
  const bannerTitle = <>FAQ</>
  const bannerContent = ""
  const bannerConclude = ""

  const faqs = [
    {
      question: "What type of events do you cater?",
      answer: "We cater corporate events, private events, wedding events, engagement ceremonies, receptions, birthday parties, and upmarket social events. We are able to have personalized services based on the unique requirements of every event."
    },
    {
      question: "Do you have customized menus?",
      answer: "Yes. We interact with you closely to develop a customized menu based on your preference, occasion theme, and dietary needs. Whether your style is vintage pizzazz or contemporary fusion, we've got it."
    },
    {
      question: "Where are your services located?",
      answer: "We are located in [City Name, i.e., Hyderabad] and cover events within the city and suburbs. For destination events or outstation services, please get in touch with us for feasibility and travel plans."
    },
    {
      question: "Why is your caterer premium?",
      answer: "Our premium service is attention to detail at every level—gourmet cuisine and presentation, professional staff and flawless execution. We try to provide you with a superior dining experience with excellent service."
    },
    {
      question: "Do you have tasting sessions prior to booking?",
      answer: "Yes, private tasting for big events or weddings may be arranged. So, you will be able to taste and finalize the menu confidently prior to the actual day."
    },
    {
      question: "How in advance should we book?",
      answer: "It is best to book 4–6 weeks in advance to avoid disappointment, particularly in wedding or festival season. Booking in advance for large groups."
    },
    {
      question: "Do you accommodate diet and special requirements?",
      answer: "Yes. We support vegetarian, vegan, Jain, gluten-free, and many other diets. Let us know what you need, and we will prepare a menu that will make everyone smile."
    },
    {
      question: "Do you have live counters or chef stations?",
      answer: "Yes. We provide high-end live counters with in-house chefs preparing live before your guests to provide them with a live and gourmet food experience that their guests will remember."
    },
    {
      question: "Do you provide full-service catering complete with service staff and setup?",
      answer: "Yes. Our catering is the whole shebang—food, presentation, serving staff, setup, and cleanup—so that you can sit back and enjoy your party without worrying about a thing."
    },
    {
      question: "What's your pricing structure?",
      answer: "Our prices vary based on your choice of menu, number of visitors, event venue, and services to be provided. We give you individualized quotes based on your event specifications after our consultation."
    },
    {
      question: "Is there a minimum number of visitors?",
      answer: "Yes, generally we hold events with at least [e.g., 50 or 100] people in an attempt to uphold our standards of quality. We will work smaller events, give us a call and ask if you can still hire us."
    },
    {
      question: "Do you also do decor or event planning?",
      answer: "While our forte is upscale catering, we also regularly collaborate with premier event coordinators and decorators. If desired, we would be more than willing to refer experienced partners to help realize your entire event idea."
    },
    {
      question: "How is my service booked?",
      answer: "Just contact us through our [Contact Page], call us, or complete the event inquiry form. We will reach out to you for a consultative meeting and tailor-made proposal."
    },
  ]

  return (
    <section className='faq'>
      <Banner
        image={BannerImage}
        propAlt="Home Banner"
        bannerTitle={bannerTitle}
        bannerContent={bannerContent}
        bannerConclude={bannerConclude}
      />
      <section className='faq-que py-5'>
        <Container>
          <Row>
            <Col xs={12}>
              <h2 class="text-center mb-5">Frequently Asked Questions</h2>
              <Accordion>
                {faqs.map((faq, index) => (
                  <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body>{faq.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
    </section>
  )
}

export default Faq
